import React, {useCallback} from 'react';
import {
  Avatar,
  Icon,
  Layout,
  Menu,
  Popup,
  Spacer,
  Text,
} from '@di-nxt/components';
import {TeamMember} from '../../../services';

type Props = {
  member: TeamMember;
  onMemberSelect: (id: number) => void;
  onDeleteUser: (mobileNo: string) => void;
};

export const MemberItem: React.FC<Props> = ({
  member,
  onMemberSelect,
  onDeleteUser,
}) => {
  const handleActionSelected = useCallback(
    (index: number) => {
      switch (index) {
        case 0: {
          member.mobileNo && onDeleteUser(member.mobileNo);
          break;
        }
      }
    },
    [member.mobileNo, onDeleteUser],
  );

  const handleSelectMember = useCallback(
    () => onMemberSelect && onMemberSelect(member.membershipId),
    [member.membershipId, onMemberSelect],
  );

  return (
    <Layout
      horizontal
      align="center"
      paddingHorizontal="20"
      paddingVertical="16"
      borderBottomColor="border_mono_15"
      borderBottomWidth="1"
      borderBottomStyle="solid"
      justify="space-between">
      <Layout horizontal align="center" flex onPress={handleSelectMember}>
        <Avatar name={member.fullname} uri={member.avatarUrl} />
        <Spacer width="16" />
        <Layout vertical>
          <Text variant="inline_14_emphasis">{member.display}</Text>
          {member.title && (
            <>
              <Spacer height="6" />
              <Text variant="inline_12_default">{member.title}</Text>
            </>
          )}
        </Layout>
      </Layout>
      <Layout>
        <Popup trigger={<Icon name="more" />}>
          {closePopup => (
            <Menu
              items={['Remove from team', 'Add absence']}
              onChange={index => {
                handleActionSelected(index);
                closePopup();
              }}
            />
          )}
        </Popup>
      </Layout>
    </Layout>
  );
};
